import { render, staticRenderFns } from "./chooseOnceCard.vue?vue&type=template&id=7c12fe50&"
import script from "./chooseOnceCard.vue?vue&type=script&lang=js&"
export * from "./chooseOnceCard.vue?vue&type=script&lang=js&"
import style0 from "./chooseOnceCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports